import stringHelper from "../../../utils/strings";
import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createDeliveryStateHistoryReportSlice = (set, get) => ({
    deliveryStateHistory: {
        loading: false,
        data: [],
        filtered: []
    },
    getDeliveryStateHistory: async (requestId) => {
        if(!stringHelper.hasValue(requestId)) {
            return;
        }
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ deliveryStateHistory: { ...state.deliveryStateHistory, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: `/v1/business/DeliveryStateHistory/${requestId}`,
                headers: { token },
            });
            set(state => ({ deliveryStateHistory: { loading: false, data: resp.data, filtered: resp.data } }));
        } catch (error) {
            set(state => ({ deliveryStateHistory: { ...state.deliveryStateHistory, loading: false } }));
        }
    }
});
